import React from 'react'
import POSTable from './components'

export default function RedemptionVault() {

  return (
    <section>
      <POSTable />
    </section>
  )
}
